import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const mtgServiceUrl = { baseURL: environment.get().api.meetingServiceURL };
const mtgServiceSettingsEndpoint = appconfig.endpoints.mtgServiceSettings;

export const daoExtMeetingServiceSettingsGet = () => api.get(`${mtgServiceSettingsEndpoint}`, mtgServiceUrl);
